var _circle, _circle2, _circle3, _circle4, _circle5, _circle6, _circle7, _circle8, _circle9, _circle10, _circle11, _circle12, _circle13, _circle14, _circle15, _circle16, _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBubbles(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 346,
    height: 380,
    viewBox: "0 0 346 380",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 280.313,
    cy: 58.9932,
    r: 58.9932,
    transform: "rotate(90 280.313 58.9932)",
    fill: "url(#paint0_radial)"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 222.465,
    cy: 257.738,
    r: 20.619,
    transform: "rotate(90 222.465 257.738)",
    fill: "white"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.5,
    cx: 153.734,
    cy: 134.022,
    r: 37.3835,
    transform: "rotate(90 153.734 134.022)",
    stroke: "#FFFBFB",
    strokeWidth: 10
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 201.847,
    cy: 12.6006,
    r: 3.4365,
    transform: "rotate(90 201.847 12.6006)",
    fill: "#2AF4D5"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 66.104,
    cy: 179.271,
    r: 1.71825,
    transform: "rotate(90 66.104 179.271)",
    fill: "#F2F2F2"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 213.876,
    cy: 223.945,
    r: 1.71825,
    transform: "rotate(90 213.876 223.945)",
    fill: "#F2F2F2"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 106.771,
    cy: 234.827,
    r: 5.7275,
    transform: "rotate(90 106.771 234.827)",
    fill: "#56CCF2"
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 338.733,
    cy: 291.529,
    r: 6.30025,
    transform: "rotate(90 338.733 291.529)",
    fill: "#2AF4D5"
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    cx: 287.759,
    cy: 320.739,
    r: 12.6005,
    transform: "rotate(90 287.759 320.739)",
    fill: "#1358B4"
  })), _circle10 || (_circle10 = /*#__PURE__*/React.createElement("circle", {
    cx: 148.009,
    cy: 57.2743,
    r: 12.6005,
    transform: "rotate(90 148.009 57.2743)",
    fill: "#56CCF2"
  })), _circle11 || (_circle11 = /*#__PURE__*/React.createElement("circle", {
    cx: 270.003,
    cy: 170.107,
    r: 19.6282,
    transform: "rotate(90 270.003 170.107)",
    stroke: "#56CCF2",
    strokeWidth: 10
  })), _circle12 || (_circle12 = /*#__PURE__*/React.createElement("circle", {
    cx: 105.05,
    cy: 267.473,
    r: 146.051,
    transform: "rotate(90 105.05 267.473)",
    fill: "url(#paint1_radial)"
  })), _circle13 || (_circle13 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.2,
    cx: 41.4759,
    cy: 270.337,
    r: 37.8015,
    transform: "rotate(90 41.4759 270.337)",
    fill: "#2AF4D5"
  })), _circle14 || (_circle14 = /*#__PURE__*/React.createElement("circle", {
    cx: 64.3858,
    cy: 80.1845,
    r: 13.3915,
    transform: "rotate(90 64.3858 80.1845)",
    stroke: "#2AF4D5",
    strokeWidth: 3
  })), _circle15 || (_circle15 = /*#__PURE__*/React.createElement("circle", {
    cx: 237.929,
    cy: 100.231,
    r: 6.94575,
    transform: "rotate(90 237.929 100.231)",
    stroke: "#2AF4D5"
  })), _circle16 || (_circle16 = /*#__PURE__*/React.createElement("circle", {
    cx: 142.853,
    cy: 283.51,
    r: 6.94575,
    transform: "rotate(90 142.853 283.51)",
    stroke: "#2AF4D5"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 298.067,
    cy: 242.847,
    r: 9.80949,
    transform: "rotate(90 298.067 242.847)",
    stroke: "#2AF4D5"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f",
    x: 283.758,
    y: 228.537,
    width: 28.619,
    height: 28.619,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2,
    result: "effect1_foregroundBlur"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(280.313 58.9932) rotate(90) scale(58.9932)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.694738,
    stopColor: "#00D1FF",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5AE1FF",
    stopOpacity: 0.11
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(105.05 267.473) rotate(90) scale(146.051)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.826779,
    stopColor: "#00D1FF",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5AE1FF",
    stopOpacity: 0.18
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBubbles);
export default __webpack_public_path__ + "static/media/bubbles.91bb2eca3fbae1ddfe521496c192012d.svg";
export { ForwardRef as ReactComponent };